import api from './client';

export const cmsApi = {
  getContent: () => api.get('/cms/content'),
  updateContent: (data) => api.put('/admin/site-content', data),
  getMaintenanceStatus: () => api.get('/cms/maintenance-status'),
  getCategories: () => api.get('/cms/categories'),
  createCategory: (data) => api.post('/cms/categories', data),
  updateCategory: (categoryId, data) => api.put(`/cms/categories/${categoryId}`, data),
  deleteCategory: (categoryId) => api.delete(`/cms/categories/${categoryId}`),
};
